<template>
	<div class="editor">
		<!-- 标题 -->
		<div class="editor-title flex_c">
			<!-- 图片 -->
			<img :src="curItem.icon || projectinfo.image_url" width="20px" />
			<!-- <i class="el-icon-s-tools" style="font-size: 16px"></i> -->
			<span style="margin-left: 5px">
				<!-- {{
        selectedIndex === "page" ? data.page.name : curItem.name
      }} -->
				{{ selectedIndex === "page" ? projectinfo.title : curItem.name }}
			</span>
		</div>

		<!-- 编辑器: 标题栏 -->
		<div v-if="selectedIndex === 'page'" class="editor-content editor-content-banner">
			<!-- <el-tabs>
        <el-tab-pane key="1" label="页面设置"> -->
			<div class="block-box">
				<!-- <div class="block-title">基本信息</div> -->
				<!-- <div class="tips_head">
					当导航选择沉浸式，背景样式设置仅在APP、微信小程序中生效
				</div> -->
				<div class="block-item has-tips block-item-class mt10">
					<span class="label">页面名称</span>
					<div class="flex-box">
						<el-input size="small" v-model="data.page.params.name" />
					</div>
				</div>
				<div class="block-item block-item-class">
					<span class="label">页面背景</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" backgroundPage v-model="data.page.style.backgroundPage"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.backgroundPage" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
			          onEditorResetColor(
			            data.page.style,
			            'backgroundPage',
			            '#fff'
			          )
			        "> 重置
							</div>
						</div>
					</div>
				</div>
				<div class="block-item has-tips block-item-class mt10">
					<span class="label">功能模块</span>
					<div class="flex-box">
						<el-radio-group v-model="data.page.params.model_type" type="button">
							<el-radio label="0">无</el-radio>
							<el-radio label="1">沉浸式</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div v-if="data.page.params.model_type==1" class="block-item block-item-class">
					<span class="label">导航背景</span>
					<el-radio-group v-model="data.page.params.bgstyle" type="button">
						<el-radio :label="1">纯色</el-radio>
						<el-radio :label="2">图片</el-radio>
					</el-radio-group>
				</div>
				<div v-if="data.page.params.bgstyle==2&&data.page.params.model_type==1"
					class="block-item has-tips block-item-class">
					<span class="label">导航图片</span>
					<div class="flex-box">
						<SImage v-model="data.page.style.titleBackgroundImg" />
						<div class="tips">建议尺寸750*196</div>
					</div>
				</div>
				<div v-if="data.page.params.bgstyle==1&&data.page.params.model_type==1"
					class="block-item block-item-class">
					<span class="label">导航颜色</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" v-model="data.page.style.titleBackgroundColor"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.titleBackgroundColor" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
			          onEditorResetColor(
			            data.page.style,
			            'titleBackgroundColor',
			            '#fff'
			          )
			        ">
								重置
							</div>
						</div>
					</div>
				</div>
				<div v-if="data.page.params.model_type!=1" class="block-item block-item-class">
					<span class="label">导航颜色</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" v-model="data.page.style.titleBackgroundColor"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.titleBackgroundColor" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
			          onEditorResetColor(
			            data.page.style,
			            'titleBackgroundColor',
			            '#fff'
			          )
			        ">
								重置
							</div>
						</div>
					</div>
				</div>
				<div v-if="data.page.params.model_type!=1" class="block-item has-tips block-item-class">
					<span class="label">导航标题</span>
					<div class="flex-box">
						<el-input size="small" v-model="data.page.params.title" />
						<div class="tips">用户端端顶部显示的标题</div>
					</div>
				</div>
				<div v-if="data.page.params.model_type!=1" class="block-item block-item-class">
					<span class="label">文字颜色</span>
					<el-radio-group v-model="data.page.style.titleTextColor" type="button">
						<el-radio label="white">白色</el-radio>
						<el-radio label="black">黑色</el-radio>
					</el-radio-group>
				</div>
				<!-- <div v-if="data.page.params.model_type==1" class="block-item has-tips block-item-class mt10">
					<span class="label">多门店显示</span>
					<div class="flex-box">
						<el-radio-group v-model="data.page.params.storeShow" type="button">
							<el-radio label="1">显示</el-radio>
							<el-radio label="2">不显示</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div v-if="data.page.params.model_type==1&&data.page.params.storeShow==1"
					class="block-item block-item-class">
					<span class="label">多门店文字</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" v-model="data.page.style.searchTitTextColor"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.searchTitTextColor" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
			          onEditorResetColor(
			            data.page.style,
			            'searchTitTextColor',
			            '#fff'
			          )
			        ">
								重置
							</div>
						</div>
					</div>
				</div>
				<div v-if="data.page.params.model_type==1" class="block-item has-tips block-item-class mt10">
					<span class="label">搜索框显示</span>
					<div class="flex-box">
						<el-radio-group v-model="data.page.params.searchShow" type="button">
							<el-radio label="1">显示</el-radio>
							<el-radio label="2">不显示</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div v-if="data.page.params.model_type==1&&data.page.params.searchShow==1"
					class="block-item block-item-class">
					<span class="label">搜索框文字</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" v-model="data.page.style.searchTextColor"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.searchTextColor" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
			          onEditorResetColor(
			            data.page.style,
			            'searchTextColor',
			            '#fff'
			          )
			        ">
								重置
							</div>
						</div>
					</div>
				</div> -->
				<!-- <div v-if="data.page.params.model_type==1&&data.page.params.searchShow==1"
					class="block-item block-item-class">
					<span class="label">搜索框背景</span>
					<div class="item-colorPicker">
						<div class="color-picker-box">
							<el-color-picker size="small" v-model="data.page.style.searchBackgroudColor"
								defaultColor="#fff" />
						</div>
						<div class="reset-color">
							<div class="ipt">
								<SInput v-model="data.page.style.searchBackgroudColor" width="100px" height="32px"
									border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
							</div>
							<div class="color-txt" @click="
			          onEditorResetColor(
			            data.page.style,
			            'searchBackgroudColor',
			            '#fff'
			          )
			        ">
								重置
							</div>
						</div>
					</div>
				</div>
				<div v-if="data.page.params.model_type==1&&data.page.params.searchShow==1"
					class="block-item has-tips block-item-class">
					<span class="label">搜索框提示</span>
					<div class="flex-box">
						<el-input size="small" v-model="data.page.params.searchTips" />
						<div class="tips">搜索框内提示内容</div>
					</div>
				</div> -->
			</div>
			<!-- </el-tab-pane>
        <el-tab-pane key="2" label="标题栏设置"> -->
			<!-- </el-tab-pane>
      </el-tabs> -->
		</div>

		<template v-if="data.items.length && curItem">
			<!-- 搜索栏 -->
			<div v-if="curItem.type == 'search'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="block-box">
					<div class="block-title">功能设置</div>
					<div class="block-item block-item-class">
						<span class="label">提示文字</span>
						<el-input size="small" v-model="curItem.params.placeholder" />
					</div>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<div class="block-title">内容样式</div>
					<div class="block-item block-item-class">
						<span class="label">搜索框样式</span>
						<RadioGroup v-model="curItem.style.searchStyle" type="button">
							<Radio label="square">方形</Radio>
							<Radio label="radius">圆角</Radio>
							<Radio label="round">圆弧</Radio>
						</RadioGroup>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字对齐</span>
						<RadioGroup v-model="curItem.style.textAlign" type="button">
							<Radio label="left">居左</Radio>
							<Radio label="center">居中</Radio>
							<Radio label="right">居右</Radio>
						</RadioGroup>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.radiusTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'radiusTop')" v-model="curItem.style.radiusTop"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.radiusBottom" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'radiusBottom')"
							v-model="curItem.style.radiusBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
							<!-- <span class="unit-text">
			        <span>{{ curItem.style.paddingTop }}</span>
			        <span>像素</span>
			      </span> -->
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
							<!-- <span class="unit-text">
			        <span>{{ curItem.style.paddingBottom }}</span>
			        <span>像素</span>
			      </span> -->
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
							v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
							<!-- <span class="unit-text">
			        <span>{{ curItem.style.paddingLeft }}</span>
			        <span>像素</span>
			      </span> -->
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
							<!-- <span class="unit-text">
			        <span>{{ curItem.style.paddingRight }}</span>
			        <span>像素</span>
			      </span> -->
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
							v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
			            onEditorResetColor(curItem.style, 'zubackground', '#fff')
			          ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">搜索背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background"
									defaultColor="#f9f9f9" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
			            onEditorResetColor(curItem.style, 'background', '#fff')
			          ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">边框颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.borderColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.borderColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt"
									@click=" onEditorResetColor(curItem.style, 'borderColor', '#fff') ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.color" defaultColor="#000" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.color" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#000"></SInput>
								</div>
								<div class="color-txt" @click="
			            onEditorResetColor(curItem.style, 'color', '#000')
			          ">
									重置
								</div>
							</div>
							<!-- <span
			        class="rest-color"
			        @click="onEditorResetColor(curItem.style, 'background', '#fff')"
			        >重置</span
			      >
			      <el-color-picker
			        size="small"
			        v-model="curItem.style.background"
			        defaultColor="#fff"
			      /> -->
						</div>
					</div>
				</div>
				<!--  </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 辅助空白 -->
			<div v-if="curItem.type == 'blank'" class="editor-content editor-content-banner">
				<div class="block-box">
					<!-- <div class="block-title">样式设置</div> -->
					<!-- <div class="block-item block-item-class">
						<span class="label">组件高度</span>
						<div class="item-slider">
							<el-slider style="width: 160px" v-model="curItem.style.height" :min="5" :max="200" />
							<span class="unit-text">
								<span>{{ curItem.style.height }}</span>
								<span>像素</span>
							</span>
						</div>
					</div> -->
					<div class="block-item block-item-class">
					  <span class="label">组件高度</span>
					  <div class="item-slider">
					    <el-slider  style="width: 100%" v-model="curItem.style.height" :min="5" :max="200" />
					  </div>
									<el-input type="number" @input="e=>changeInput(e,'height')" v-model="curItem.style.height" size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入" >
									  <span slot="suffix" class="input_text" style="">PX</span>
									</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                    onEditorResetColor(curItem.style, 'background', '#fff')
                  ">
									重置
								</div>
							</div>
							<!-- <span
                class="rest-color"
                @click="onEditorResetColor(curItem.style, 'background', '#fff')"
                >重置</span
              >
              <el-color-picker
                size="small"
                v-model="curItem.style.background"
                defaultColor="#fff"
              /> -->
						</div>
					</div>
				</div>
			</div>

			<!-- 辅助线 -->
			<div v-if="curItem.type == 'guide'" class="editor-content editor-content-banner">
				<div class="block-box">
					<!-- <div class="block-title">样式设置</div> -->
					<div class="block-item block-item-class">
						<span class="label">线条样式</span>
						<el-radio-group v-model="curItem.style.lineStyle" type="button">
							<el-radio label="solid">实线</el-radio>
							<el-radio label="dashed">虚线</el-radio>
							<el-radio label="dotted">点状</el-radio>
						</el-radio-group>
						<!-- <el-radio-group
              size="small"
              buttonStyle="solid"
              v-model="curItem.style.lineStyle"
            >
              <el-radio-button label="solid">实线</el-radio-button>
              <el-radio-button label="dashed">虚线</el-radio-button>
              <el-radio-button label="dotted">点状</el-radio-button>
            </el-radio-group> -->
					</div>
					<div class="block-item block-item-class">
						<span class="label">线条颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.lineColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.lineColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                    onEditorResetColor(curItem.style, 'lineColor', '#000')
                  ">
									重置
								</div>
							</div>
							<!-- <span
                class="rest-color"
                @click="onEditorResetColor(curItem.style, 'lineColor', '#000')"
                >重置</span
              >
              <el-color-picker
                size="small"
                v-model="curItem.style.lineColor"
                defaultColor="#000"
              /> -->
						</div>
					</div>
					<div class="block-item block-item-class">
					  <span class="label">线条高度</span>
					  <div class="item-slider">
					    <el-slider  style="width: 100%" v-model="curItem.style.lineHeight" :min="0" :max="20" />
					  </div>
									<el-input type="number" @input="e=>changeInput(e,'lineHeight')" v-model="curItem.style.lineHeight" size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入" >
									  <span slot="suffix" class="input_text" style="">PX</span>
									</el-input>
					</div>
					<div class="block-item block-item-class">
					  <span class="label">上下边距</span>
					  <div class="item-slider">
					    <el-slider  style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
					  </div>
									<el-input type="number" @input="e=>changeInput(e,'paddingTop')" v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入" >
									  <span slot="suffix" class="input_text" style="">PX</span>
									</el-input>
					</div>
					<div class="block-item block-item-class">
					  <span class="label">左右边距</span>
					  <div class="item-slider">
					    <el-slider  style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
					  </div>
									<el-input type="number" @input="e=>changeInput(e,'paddingLeft')" v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入" >
									  <span slot="suffix" class="input_text" style="">PX</span>
									</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                    onEditorResetColor(curItem.style, 'background', '#fff')
                  ">
									重置
								</div>
							</div>
							<!-- <span
                class="rest-color"
                @click="onEditorResetColor(curItem.style, 'background', '#fff')"
                >重置</span
              >
              <el-color-picker
                size="small"
                v-model="curItem.style.background"
                defaultColor="#fff"
              /> -->
						</div>
					</div>
				</div>
			</div>
			<!-- 门店切换 -->
			<!-- 富文本 -->
				<div v-if="curItem.type == 'richText'" 
					class="editor-content editor-content-banner">
					<!-- <el-tabs>
			  <el-tab-pane key="1" label="内容设置"> -->
					<div class="block-box" style="margin-bottom: 35px;">
						<!-- <div class="block-title">文本内容</div> -->
						<div class="ueditor">
							<tinymce-editor style="width: 480px" :id="'s1'" ref="editor1" :height="600"
								v-model="curItem.params.content" :disabled="false"></tinymce-editor>
							<!--<Ueditor v-model="curItem.params.content" :config="{ initialFrameWidth:  375 }" />-->
						</div>
					</div>
					<!-- </el-tab-pane>
			  <el-tab-pane key="2" label="样式设置"> -->
					<div class="block-box">
						<!-- <div class="block-title">组件样式</div> -->
						<div class="block-item block-item-class">
							<span class="label">上边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
								v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">下边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
								v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">左边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
								v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">右边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
								v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">组件背景</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.background" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
			                onEditorResetColor(curItem.style, 'background', '#fff')
			              ">
										重置
									</div>
								</div>
								<!-- <span
			            class="rest-color"
			            @click="
			              onEditorResetColor(curItem.style, 'background', '#fff')
			            "
			            >重置</span
			          >
			          <el-color-picker
			            size="small"
			            v-model="curItem.style.background"
			            defaultColor="#fff"
			          /> -->
							</div>
						</div>
					</div>
					<!-- </el-tab-pane>
			</el-tabs> -->
				</div>

			<!-- 店铺公告 -->
			<div v-if="curItem.type == 'notice'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="block-box">
					<div class="block-title">公告文案</div>
					<div class="block-item block-item-class">
						<span class="label">内容</span>
						<el-input size="small" v-model="curItem.params.text" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">链接</span>
						<div class="flex-box">
							<SLink v-model="curItem.params.link" />
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<div class="block-title">内容样式</div>
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.textColor" defaultColor="#000" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.textColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'textColor', '#000')
                      ">
									重置
								</div>
							</div>
							<!-- <span
                    class="rest-color"
                    @click="
                      onEditorResetColor(curItem.style, 'textColor', '#000')
                    "
                    >重置</span
                  >
                  <el-color-picker
                    size="small"
                    v-model="curItem.style.textColor"
                    defaultColor="#000"
                  /> -->
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'background', '#fff')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<div class="block-title">组件样式</div>
					<div class="block-item block-item-class">
						<span class="label">上下边距</span>
						<div class="item-slider">
							<el-slider style="width: 160px" v-model="curItem.style.paddingTop" :min="0" :max="50" />
							<span class="unit-text">
								<span>{{ curItem.style.paddingTop }}</span>
								<span>像素</span>
							</span>
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>
			<!-- 线下取积分 -->
			<div v-if="curItem.type == 'pointeroffline'" class="editor-content editor-content-banner">
				<div class="block-box">
					<div class="block-item block-item-class">
						<span class="label">按钮内容</span>
						<el-input size="small" v-model="curItem.params.but" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.btnRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'btnRadius')" v-model="curItem.style.btnRadius"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.btnBg"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.btnBg" width="100px" height="32px" border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'btnBg', '#fff') "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.btnColor"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.btnColor" width="100px" height="32px" border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'btnColor', '#fff') "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮文字大小</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.btnFont" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'btnFont')" v-model="curItem.style.btnFont"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">主标题内容</span>
						<el-input size="small" v-model="curItem.params.title" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">主标题文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.titleColor"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.titleColor" width="100px" height="32px" border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'titleColor', '#fff') "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">主标题文字大小</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.titleFont" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'titleFont')" v-model="curItem.style.titleFont"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">金额文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.moneyColor"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.moneyColor" width="100px" height="32px" border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'moneyColor', '#fff') "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">金额文字大小</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.moneyFont" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'moneyFont')" v-model="curItem.style.moneyFont"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')" v-model="curItem.style.borderRadius"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
						onEditorResetColor(curItem.style, 'background', '#fff')
					  "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
						onEditorResetColor(curItem.style, 'zubackground', '#fff')
					  "> 重置 </div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 余额 -->
			<div v-if="curItem.type == 'balance'" class="editor-content editor-content-banner">
				<div class="block-box">
					<div class="block-item block-item-class">
						<span class="label">按钮内容</span>
						<el-input size="small" v-model="curItem.params.but" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.btnRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'btnRadius')" v-model="curItem.style.btnRadius"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.btnBg"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.btnBg" width="100px" height="32px" border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'btnBg', '#fff') "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.btnColor"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.btnColor" width="100px" height="32px" border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'btnColor', '#fff') "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮文字大小</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.btnFont" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'btnFont')" v-model="curItem.style.btnFont"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div  class="block-item has-tips block-item-class">
						<span class="label">主标题图标</span>
						<div class="flex-box">
							<SImage v-model="curItem.params.icon" />
							<div class="tips">建议尺寸80*80</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">主标题内容</span>
						<el-input size="small" v-model="curItem.params.title" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">主标题文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.titleColor"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.titleColor" width="100px" height="32px" border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'titleColor', '#fff') "> 重置 </div>
							</div>
						</div>
					</div>
					<!-- <div class="block-item block-item-class">
						<span class="label">主标题文字大小</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.titleFont" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'titleFont')" v-model="curItem.style.titleFont"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div> -->
					<!-- <div class="block-item block-item-class">
						<span class="label">副标题内容</span>
						<el-input size="small" v-model="curItem.params.sub" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">副标题文字大小</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.subFont" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'subFont')" v-model="curItem.style.subFont"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div> -->
					<div class="block-item block-item-class">
						<span class="label">副标题文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.subColor"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.subColor" width="100px" height="32px" border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'subColor', '#fff') "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">金额单位</span>
						<el-input size="small" v-model="curItem.params.money" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">金额文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.moneyColor"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.moneyColor" width="100px" height="32px" border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'moneyColor', '#fff') "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')" v-model="curItem.style.borderRadius"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
						onEditorResetColor(curItem.style, 'background', '#fff')
					  "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
						onEditorResetColor(curItem.style, 'zubackground', '#fff')
					  "> 重置 </div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 文章组 -->
			<div v-if="curItem.type == 'article'" class="editor-content editor-content-banner">
				<div class="block-box">
					<div class="block-title">文章内容</div>
					<div class="block-item block-item-class">
						<span class="label">文章分类</span>
						<SArticleCate v-model="curItem.params.auto.category" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">显示数量</span>
						<div class="block-item-right flex_c_s">
							<el-input size="small" class="flex1" v-model="curItem.params.auto.showNum" :min="1"
								:max="20" />
							<span class="unit-text">
								<span>篇</span>
							</span>
						</div>
					</div>
				</div>
			</div>

			<!-- 在线客服 -->
			<div v-if="curItem.type == 'service'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="block-box">
					<div class="block-title">功能设置</div>
					<div class="block-item block-item-class">
						<span class="label">客服类型</span>
						<!-- <el-radio-group
                  size="small"
                  buttonStyle="solid"
                  v-model="curItem.params.type"
                >
                  <el-radio-button label="chat">在线聊天</el-radio-button>
                  <el-radio-button label="phone">拨打电话</el-radio-button>
                </el-radio-group> -->
						<RadioGroup v-model="curItem.params.type" type="button">
							<Radio label="chat">在线聊天</Radio>
							<Radio label="phone">拨打电话</Radio>
						</RadioGroup>
					</div>
					<div v-show="curItem.params.type == 'phone'" class="block-item">
						<span class="label">电话号码</span>
						<el-input size="small" v-model="curItem.params.tel" />
					</div>
					<div class="block-item">
						<span class="label">客服图标</span>
						<span class="tips-wrap">建议尺寸90×90</span>
						<SImage v-model="curItem.params.image" :width="60" :height="60" />
					</div>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<div class="block-title">组件样式</div>
					<div class="block-item block-item-class">
						<span class="label">宽度</span>
						<div class="item-slider">
							<el-slider style="width: 160px" v-model="curItem.style.width" :min="0" :max="150" />
							<span class="unit-text">
								<span>{{ curItem.style.width }}</span>
								<span>像素</span>
							</span>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">高度</span>
						<div class="item-slider">
							<el-slider style="width: 160px" v-model="curItem.style.height" :min="0" :max="150" />
							<span class="unit-text">
								<span>{{ curItem.style.height }}</span>
								<span>像素</span>
							</span>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">底边距</span>
						<div class="item-slider">
							<el-slider style="width: 160px" v-model="curItem.style.bottom" :min="0" :max="300" />
							<span class="unit-text">
								<span>{{ curItem.style.bottom }}</span>
								<span>像素</span>
							</span>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 160px" v-model="curItem.style.right" :min="0" :max="200" />
							<span class="unit-text">
								<span>{{ curItem.style.right }}</span>
								<span>像素</span>
							</span>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">不透明度</span>
						<div class="item-slider">
							<el-slider style="width: 160px" v-model="curItem.style.opacity" :min="0" :max="100" />
							<span class="unit-text">
								<span>{{ curItem.style.opacity }}</span>
								<span>%</span>
							</span>
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>
			<!-- 绑定手机 -->
			<div v-if="curItem.type == 'modulephone'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
	    <el-tab-pane key="1" label="内容设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">功能设置</div> -->
					<div class="block-item block-item-class">
						<span class="label">提示文字</span>
						<el-input size="small" v-model="curItem.params.text" />
					</div>
					<div class="block-item block-item-class  " >
						<span class="label">按钮文字</span>
						<el-input size="small" v-model="curItem.params.buttext" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">微信图标</span>
						<span class="tips-wrap">建议尺寸90×90</span>
						<SImage v-model="curItem.params.image" :width="60" :height="60" />
					</div>
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')" v-model="curItem.style.borderRadius"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius1')" v-model="curItem.style.borderRadius1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			            onEditorResetColor(curItem.style, 'zubackground', '#fff')
			          "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
					    onEditorResetColor(curItem.style, 'background', '#fff')
					  "> 重置 </div>
							</div>
						</div>
					</div>
					
					<div class="block-item block-item-class">
						<span class="label">提示文字</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.textColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.textColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
					    onEditorResetColor(curItem.style, 'textColor', '#fff')
					  "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮文字</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.butColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.butColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
					    onEditorResetColor(curItem.style, 'butColor', '#fff')
					  "> 重置 </div>
							</div>
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
	  </el-tabs> -->
			</div>
			<!-- 图片组 -->
			<div v-if="curItem.type == 'image'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="sub-title">添加图片 (最多10张，可拖动排序）</div>
				<draggable :list="curItem.data" v-bind="{
                animation: 120,
                filter: 'input',
                preventOnFilter: false,
              }">
					<div v-for="(item, index) in curItem.data" :key="index" style="margin-top:10px" class="block-box drag drage-banner">
						<div class="block-title">
							<!-- <span class="left">图片 {{ index + 1 }}</span> -->
							<a class="link" @click="handleDeleleData(curItem, index)"><i class="el-icon-error"></i></a>
						</div>
						<div class="block-item">
							<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
							<div class="block-item-custom">
								<SImage v-model="item.imgUrl" tips="建议尺寸宽750"
									@update="item.imgName = $event.file_name" />
							</div>
							<div class="block-item-common">
								<div class="block-item-common-row">
									<span class="label">图片名称</span>
									<span class="label value">{{ item.imgName }}</span>
								</div>
								<div class="block-item-common-row">
									<!-- <span class="label">链接</span> -->
									<SLink v-model="item.link" />
								</div>
								<span>建议图片宽度750px</span>
							</div>
						</div>
					</div>
				</draggable>
				<div v-if="curItem.data.length < 10" class="data-add">
					<el-button icon="plus" @click="handleAddData(10)">添加图片</el-button>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<div class="block-title">组件样式</div>
					<div class="block-item block-item-class">
					  <span class="label">上下边距</span>
					  <div class="item-slider">
					    <el-slider  style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
					  </div>
									<el-input type="number" @input="e=>changeInput(e,'paddingTop')" v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入" >
									  <span slot="suffix" class="input_text" style="">PX</span>
									</el-input>
					</div>
					<div class="block-item block-item-class">
					  <span class="label">左右边距</span>
					  <div class="item-slider">
					    <el-slider  style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
					  </div>
									<el-input type="number" @input="e=>changeInput(e,'paddingLeft')" v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入" >
									  <span slot="suffix" class="input_text" style="">PX</span>
									</el-input>
					</div>
					<div class="block-item block-item-class">
					  <span class="label">圆角尺寸</span>
					  <div class="item-slider">
					    <el-slider  style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="20" />
					  </div>
									<el-input type="number" @input="e=>changeInput(e,'borderRadius')" v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入" >
									  <span slot="suffix" class="input_text" style="">PX</span>
									</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'background', '#fff')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 轮播图 -->
				<div v-if="curItem.type == 'banner'" class="editor-content editor-content-banner">
					<!-- <el-tabs>
			  <el-tab-pane key="1" label="内容设置"> -->
					<div class="sub-title">添加图片 (最多10张，可拖动排序）</div>
					<draggable :list="curItem.data" v-bind="{
			        animation: 120,
			        filter: 'input',
			        preventOnFilter: false,
			      }">
						<div v-for="(item, index) in curItem.data" :key="index" style="margin-top:10px" class="block-box drag drage-banner">
							<div class="block-title">
								<a class="link" @click="handleDeleleData(curItem, index)">
									<i class="el-icon-error"></i></a>
							</div>
							<div class="block-item">
								<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
								<div class="block-item-custom">
									<SImage width="70px" height="70px" v-model="item.imgUrl" tips="建议尺寸750×400"
										@update="item.imgName = $event.filename" />
								</div>
								<div class="block-item-common">
									<div class="block-item-common-row">
										<SLink v-model="item.link" />
									</div>
									<span>建议图片宽度750px，高度跟随第一张图片的高度变化</span>
								</div>
							</div>
						</div>
					</draggable>
					<div v-if="curItem.data.length < 10" class="data-add">
						<el-button icon="plus" @click="handleAddData(10)">添加图片</el-button>
					</div>
					<!-- </el-tab-pane>
			  <el-tab-pane key="2" label="样式设置"> -->
					<div class="block-box" >
						<!-- <div class="block-title">内容样式</div> -->
						<div class="block-item block-item-class">
							<span class="label">指示点状态</span>
							<el-radio-group v-model="curItem.params.dot" type="button">
								<el-radio :label="1">显示</el-radio>
								<el-radio :label="2">隐藏</el-radio>
							</el-radio-group>
						</div>
						<div v-if='curItem.params.dot==1' class="block-item block-item-class">
							<span class="label">指示点形状</span>
							<el-radio-group v-model="curItem.style.btnShape" type="button">
								<el-radio label="round">圆形</el-radio>
								<!-- <el-radio label="square">正方形</el-radio>
			          <el-radio label="rectangle">长方形</el-radio> -->
								<el-radio label="num">数量</el-radio>
							</el-radio-group>
						</div>
						<div v-if='curItem.params.dot==1' class="block-item block-item-class">
							<span class="label">指示点颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.btnColor" defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.btnColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
			                onEditorResetColor(curItem.style, 'btnColor', '#fff')
			              ">
										重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">组件背景</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.background" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
									</div>
									<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'background', '#fff') ">
										重置
									</div>
								</div>
							</div>
			
						</div>
						<div class="block-item block-item-class">
							<span class="label">切换时间</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.interval" :step="1" :min="1"
									:max="20" />
								<!-- <span class="unit-text">
									<span>{{ curItem.style.interval }}</span>
									<span>秒</span>
								</span> -->
							</div>
							<el-input type="number" @input="e=>changeInput(e,'interval')" v-model="curItem.style.interval"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">秒</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">上边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">下边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">左边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">右边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<!-- <div class="block-item block-item-class">
			        <span class="label">上下边距</span>
			        <div class="item-slider">
			          <el-slider
			            style="width: 160px"
			            v-model="curItem.style.paddingY"
			            :min="0"
			            :max="30"
			          />
			          <span class="unit-text">
			            <span>{{ curItem.style.paddingY }}</span>
			            <span>像素</span>
			          </span>
			        </div>
			      </div> -->
						<!-- <div class="block-item block-item-class">
			        <span class="label">左右边距</span>
			        <div class="item-slider">
			          <el-slider
			            style="width: 160px"
			            v-model="curItem.style.paddingX"
			            :min="0"
			            :max="20"
			          />
			          <span class="unit-text">
			            <span>{{ curItem.style.paddingX }}</span>
			            <span>像素</span>
			          </span>
			        </div>
			      </div> -->
						<div class="block-item block-item-class">
							<span class="label">圆角尺寸</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="20" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
								v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<!-- <div class="block-item block-item-class">
			        <span class="label">圆角尺寸</span>
			        <div class="item-slider">
			          <el-slider
			            style="width: 160px"
			            v-model="curItem.style.borderRadius"
			            :min="0"
			            :max="20"
			          />
			          <span class="unit-text">
			            <span>{{ curItem.style.borderRadius }}</span>
			            <span>像素</span>
			          </span>
			        </div>
			      </div> -->
					</div>
					<!-- </el-tab-pane>
			</el-tabs> -->
			</div>

			<!-- 商品组 -->
				<div v-if="curItem.type == 'goods'" class="editor-content editor-content-banner">
					<!-- <el-tabs>
			  <el-tab-pane key="1" label="内容设置"> -->
					<div class="block-box">
						<div class="block-item block-item-class">
							<span class="label">商品来源</span>
							<el-radio-group size="small" @change="goodChange" v-model="curItem.params.source" type="button">
								<el-radio label="auto">自动获取</el-radio>
								<el-radio label="choice">手动选择</el-radio>
								<el-radio label="category">选择分类</el-radio>
							</el-radio-group>
						</div>
					</div>
					<!-- 手动选择 -->
					<div v-if="curItem.params.source === 'choice'" class="block-box" >
						<div class="block-title" style="margin-bottom:0">
							选择商品 ({{ curItem.data.length }}/50)
						</div>
						<small style="color:#888">最多可选择50个商品，超出将截取前50个商品</small>
						<SGoods :maxNum="50" v-model="curItem.data" />
					</div>
					<div v-if="curItem.params.source === 'category'" class="block-box">
						<div class="block-item block-item-class">
							<span class="label">商品分类</span>
							<SGoodsCate :vals="curItem.params.auto.category" @getValue="getValue" style="width: 270px">
							</SGoodsCate>
						</div>
						<div class="block-item block-item-class">
							<span class="label">显示数量</span>
							<div class="item-slider ">
								<el-slider style="width: 100%" v-model="curItem.params.auto.showNum" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeGoods(e,'showNum')"
								v-model="curItem.params.auto.showNum" size="mini" style="width: 130px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">件</span>
							</el-input>
						</div>
					</div>
					<!-- 自动获取 -->
					<div v-if="curItem.params.source === 'auto'" class="block-box">
						<!-- <div class="block-item block-item-class">
			        <span class="label">商品分类</span>
			        <SGoodsCate
			          @getValue="getValue"
			          style="width: 100%"
			        ></SGoodsCate>
			      </div> -->
						<div class="block-item block-item-class">
							<span class="label">商品排序</span>
							<el-radio-group v-model="curItem.params.auto.goodsSort" type="button">
								<el-radio label="all">默认</el-radio>
								<el-radio label="sales">销量</el-radio>
								<el-radio label="price">价格</el-radio>
							</el-radio-group>
						</div>
						<div class="block-item block-item-class">
							<span class="label">显示数量</span>
							<div class="item-slider ">
								<el-slider style="width: 100%" v-model="curItem.params.auto.showNum" :min="1" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeGoods(e,'showNum')"
								v-model="curItem.params.auto.showNum" size="mini" style="width: 130px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">件</span>
							</el-input>
			
						</div>
					</div>
					<!--  </el-tab-pane>
			  <el-tab-pane key="2" label="样式设置"> -->
					<div v-if="curItem.style.column==2" class="block-box">
						<!-- <div class="block-title">广告位设置</div> -->
						<div class="block-item block-item-class">
							<span class="label">广告位</span>
							<div class="" style="display:flex">
								<div @click="radioFun('swipter',1)" class="s_r">
									<span v-if="curItem.style.swipter==1" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">显示</span>
								</div>
								<div @click="radioFun('swipter',2)" class="s_r">
									<span v-if="curItem.style.swipter==2" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">不显示</span>
								</div>
							</div>
						</div>
						<div v-if="curItem.style.swipter==1" class="sub-title">添加图片 (最多6张，可拖动排序）</div>
						<draggable v-if="curItem.style.swipter==1" :list="curItem.swipter" v-bind="{
					  animation: 120,
					  filter: 'input',
					  preventOnFilter: false,
					}">
							<div v-for="(item, index) in curItem.swipter" :key="index" class="block-box drag drage-banner">
								<div class="block-title">
									<a class="link" @click="handleDeleleSwipter(curItem, index)">
										<i class="el-icon-error"></i></a>
								</div>
								<div class="block-item">
									<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
									<div class="block-item-custom">
										<SImage width="70px" height="70px" v-model="item.imgUrl" tips="建议尺寸360*480"
											@update="item.imgName = $event.filename" />
									</div>
									<div class="block-item-common">
										<!-- <div class="block-item-common-row">
							<span class="label">图片</span>
							<span class="label value">{{ item.imgName }}</span>
						  </div> -->
										<div class="block-item-common-row">
											<!-- <span class="label">选择链接</span> -->
											<SLink v-model="item.link" />
										</div>
										<span>建议图片宽度360*480</span>
									</div>
								</div>
							</div>
						</draggable>
						<div v-if="curItem.swipter.length < 6 && curItem.style.swipter==1" class="data-add">
							<el-button icon="plus" @click="handleAddSwipter(6)">添加广告</el-button>
						</div>
					</div>
					
					<div class="block-box">
						<div class="block-item block-item-class">
							<span class="label">内容样式</span>
							<el-radio-group v-model="curItem.style.cardType" type="button">
								<el-radio label="flat">扁平</el-radio>
								<el-radio label="card">卡片</el-radio>
							</el-radio-group>
						</div>
						<!-- <div class="block-title">商品样式</div> -->
						<div class="block-item block-item-class">
							<span class="label">显示类型</span>
							<el-radio-group v-model="curItem.style.display" type="button">
								<el-radio label="list">两列平铺</el-radio>
								<el-radio :disabled="curItem.style.column === 1" label="slide">横向滑动</el-radio>
							</el-radio-group>
						</div>
						<div class="block-item block-item-class">
							<span class="label">分列数量</span>
							<el-radio-group v-model="curItem.style.column" type="button">
								<el-radio :disabled="curItem.style.display !== 'list'" :label="1">单列</el-radio>
								<el-radio :label="2">两列</el-radio>
								<el-radio :label="3">三列</el-radio>
							</el-radio-group>
						</div>
						<div class="block-item block-item-class">
							<span class="label">商品名称</span>
							<div class="" style="display:flex">
								<div @click="checkR(curItem.style.show,'goodsName',true)" class="s_r">
									<span v-if="radioF(curItem.style.show,'goodsName')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">显示</span>
								</div>
								<div @click="checkR(curItem.style.show,'goodsName',false)" class="s_r">
									<span v-if="!radioF(curItem.style.show,'goodsName')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">不显示</span>
								</div>
							</div>
						</div>
						<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
							<span class="label">商品加粗</span>
							<el-radio-group v-model="curItem.style.goodsWeight" type="button">
								<el-radio label="normal">不加粗</el-radio>
								<el-radio label="bold">加粗</el-radio>
							</el-radio-group>
						</div>
						<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
							<span class="label">商品字号</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.goodsSize" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'goodsSize')" v-model="curItem.style.goodsSize"
								size="mini" style="width: 130px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div v-if="radioF(curItem.style.show,'goodsName')" class="block-item block-item-class">
							<span class="label">商品行数</span>
							<el-radio-group v-model="curItem.style.goodsNameRows" type="button">
								<el-radio label="one">单行</el-radio>
								<el-radio label="two">双行</el-radio>
							</el-radio-group>
						</div>
						<div class="block-item block-item-class">
							<span class="label">商品价格</span>
							<div class="" style="display:flex">
								<div @click="checkR(curItem.style.show,'goodsPrice',true)" class="s_r">
									<span v-if="radioF(curItem.style.show,'goodsPrice')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">显示</span>
								</div>
								<div @click="checkR(curItem.style.show,'goodsPrice',false)" class="s_r">
									<span v-if="!radioF(curItem.style.show,'goodsPrice')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">不显示</span>
								</div>
							</div>
						</div>
						<div v-if="radioF(curItem.style.show,'goodsPrice')" class="block-item block-item-class">
							<span class="label">价格颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.priceColor" defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.priceColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#FF0000"></SInput>
									</div>
									<div class="color-txt" @click="  onEditorResetColor( curItem.style, 'priceColor', '#FF0000' ) "> 重置 </div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">划线价格</span>
							<div class="" style="display:flex">
								<div @click="checkR(curItem.style.show,'linePrice',true)" class="s_r">
									<span v-if="radioF(curItem.style.show,'linePrice')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">显示</span>
								</div>
								<div @click="checkR(curItem.style.show,'linePrice',false)" class="s_r">
									<span v-if="!radioF(curItem.style.show,'linePrice')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">不显示</span>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">会员价格</span>
							<div class="" style="display:flex">
								<div @click="checkR(curItem.style.show,'goodsGrade',true)" class="s_r">
									<span v-if="radioF(curItem.style.show,'goodsGrade')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">显示</span>
								</div>
								<div @click="checkR(curItem.style.show,'goodsGrade',false)" class="s_r">
									<span v-if="!radioF(curItem.style.show,'goodsGrade')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">不显示</span>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">商品卖点</span>
							<div class="" style="display:flex">
								<div @click="checkR(curItem.style.show,'sellingPoint',true)" class="s_r">
									<span v-if="radioF(curItem.style.show,'sellingPoint')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">显示</span>
								</div>
								<div @click="checkR(curItem.style.show,'sellingPoint',false)" class="s_r">
									<span v-if="!radioF(curItem.style.show,'sellingPoint')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">不显示</span>
								</div>
							</div>
						</div>
						<div v-if="radioF(curItem.style.show,'sellingPoint')" class="block-item block-item-class">
							<span class="label">卖点颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.sellingColor"
										defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.sellingColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
						    onEditorResetColor(
						      curItem.style,
						      'sellingColor',
						      '#e3771f'
						    )
						  ">
										重置
									</div>
								</div>
							</div>
						</div>
						<div v-show="curItem.style.column < 3" class="block-item block-item-class">
							<span class="label">加购按钮</span>
							<div class="" style="display:flex">
								<div @click="checkR(curItem.style.show,'cartBtn',true)" class="s_r">
									<span v-if="radioF(curItem.style.show,'cartBtn')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">显示</span>
								</div>
								<div @click="checkR(curItem.style.show,'cartBtn',false)" class="s_r">
									<span v-if="!radioF(curItem.style.show,'cartBtn')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">不显示</span>
								</div>
							</div>
						</div>
						<div v-if="radioF(curItem.style.show,'cartBtn')" class="block-item block-item-class dancheck">
							<span class="label">购物车样式</span>
							<RadioGroup v-model="curItem.style.btnCartStyle" type="button">
								<Radio :label="1" style="padding:0 16px"><span class=" iconfont icon-jiagou1"></span></Radio>
								<Radio :label="2" style="padding:0 16px">
									<span class="card_style1"
										:style="{background:curItem.style.btnCartStyle==2?'#006aff':'#515a6e'}">
										<!-- <i class="iconfont icon-jiagou2" style="color:#fff;font-size:10px"></i> -->
										<i class="iconfont icon-jiagou3" style="color:#fff;font-size:10px"></i>
									</span>
								</Radio>
								<Radio :label="3" style="padding:0 16px"><span class=" iconfont icon-jiagou3"></span></Radio>
								<Radio :label="4" style="padding:0 16px"><span
										:style="{background:curItem.style.btnCartStyle==4?'#006aff':'#515a6e'}"
										class="card_style">购买</span></Radio>
							</RadioGroup>
						</div>
						<div v-if="radioF(curItem.style.show,'cartBtn')" class="block-item block-item-class">
							<span class="label">购物车颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.btnCartColor"
										defaultColor="#FF0000" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.btnCartColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
						  onEditorResetColor(
						    curItem.style,
						    'btnCartColor',
						    '#27c29a'
						  )
						">
										重置
									</div>
								</div>
							</div>
						</div>
			
						<div class="block-item block-item-class">
							<span class="label">商品销量</span>
							<div class="" style="display:flex">
								<div @click="checkR(curItem.style.show,'goodsSales',true)" class="s_r">
									<span v-if="radioF(curItem.style.show,'goodsSales')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">显示</span>
								</div>
								<div @click="checkR(curItem.style.show,'goodsSales',false)" class="s_r">
									<span v-if="!radioF(curItem.style.show,'goodsSales')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">不显示</span>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">商品标签</span>
							<div class="" style="display:flex">
								<div @click="checkR(curItem.style.show,'goodsTag',true)" class="s_r">
									<span v-if="radioF(curItem.style.show,'goodsTag')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">显示</span>
								</div>
								<div @click="checkR(curItem.style.show,'goodsTag',false)" class="s_r">
									<span v-if="!radioF(curItem.style.show,'goodsTag')" class="s_radio_y">
										<span class="s_radio_active"></span>
									</span>
									<span v-else class="s_radio">
									</span>
									<span style="margin-left: 3px;font-size:14px">不显示</span>
								</div>
							</div>
						</div>
						
						
						<div class="block-item block-item-class">
							<span class="label">热卖标签</span>
							<el-radio-group v-model="curItem.style.hotTag" type="button">
								<el-radio label="1">显示</el-radio>
								<el-radio label="2">不显示</el-radio>
							</el-radio-group>
						</div>
						<div v-if="curItem.style.hotTag==1" class="block-item has-tips block-item-class">
							<span class="label">热卖图片</span>
							<div class="flex-box">
								<SImage v-model="curItem.style.hotImg" width="70px" height="70px" />
								<div class="tips">
									建议图片大小为110*110尺寸的图片
								</div>
							</div>
						</div>
						
					</div>
					<div class="block-box">
						<!-- <div class="block-title">卡片样式</div> -->
						
						<div class="block-item block-item-class">
							<span class="label">圆角尺寸</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
								v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">商品间距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.itemMargin" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'itemMargin')"
								v-model="curItem.style.itemMargin" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
					</div>
					<div class="block-box">
						<!-- <div class="block-title">组件样式</div> -->
						<div class="block-item block-item-class">
							<span class="label">上边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">下边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">左边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">右边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">组件背景</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.background" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
			                onEditorResetColor(
			                  curItem.style,
			                  'background',
			                  '#ffffff'
			                )
			              ">
										重置
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- </el-tab-pane>
			</el-tabs> -->
				</div>

			<!-- 导航组 -->
			<div v-if="curItem.type == 'navBar'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="sub-title">
					添加导航 (最少4个，最多20个，可拖动排序)
				</div>
				<draggable :list="curItem.data" v-bind="{
                animation: 120,
                filter: 'input',
                preventOnFilter: false,
              }">
					<div v-for="(item, index) in curItem.data" :key="index" class="block-box drag drage-banner">
						<div class="block-title">
							<!-- <span class="left">导航 {{ index + 1 }}</span> -->
							<a class="link" @click="handleDeleleData(curItem, index)"><i class="el-icon-error"></i></a>
						</div>
						<div class="block-item">
							<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
							<div class="block-item-custom">
								<SImage v-model="item.imgUrl" tips="建议尺寸100×100" />
							</div>
							<div class="block-item-common">
								<div class="block-item-common-row">
									<!-- <span class="label">名称</span> -->
									<el-input size="small" v-model="item.text" />
								</div>
								<div class="block-item-common-row">
									<!-- <span class="label">链接</span> -->
									<SLink v-model="item.link" />
								</div>
							</div>
						</div>
					</div>
				</draggable>
				<div v-if="curItem.data.length < 20" class="data-add">
					<el-button icon="plus" @click="handleAddData(20)">添加导航</el-button>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<div class="block-title">内容样式</div>
					<div class="block-item block-item-class">
						<span class="label">交互样式</span>
						<RadioGroup v-model="curItem.params.interactive" type="button">
							<Radio :label="1">平滑</Radio>
							<Radio :label="2">分页</Radio>
						</RadioGroup>
					</div>
					<div v-if="curItem.params.interactive==1" class="block-item block-item-class">
						<span class="label">每页行数</span>
						<RadioGroup v-model="curItem.params.rowNum" type="button">
							<Radio :label="1">1行</Radio>
							<Radio :label="2">2行</Radio>
						</RadioGroup>
					</div>
					<div class="block-item block-item-class">
						<span class="label">每行数量</span>
						<RadioGroup v-model="curItem.style.rowsNum" type="button">
							<Radio :label="3">3个</Radio>
							<Radio :label="4">4个</Radio>
							<Radio :label="5">5个</Radio>
						</RadioGroup>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮形状</span>
						<div class="navstyle" style="display: flex;">
							<div @click="setFun(1)" :class="[curItem.style.navRadius==1?'navactive1':'navb']"
								style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;">
							</div>
							<div @click="setFun(2)" :class="[curItem.style.navRadius==2?'navactive1':'navb']"
								style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;border-radius:3px">
							</div>
							<div @click="setFun(3)" :class="[curItem.style.navRadius==3?'navactive1':'navb']"
								style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;border-radius:50%">
							</div>
							<!-- <RadioGroup v-model="curItem.style.navRadius" type="button">
					  <Radio :label="1">
						  <div style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;"></div>
					  </Radio>
					  <Radio :label="2">
						  <div style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;border-radius: 4px;"></div>
					  </Radio>
					  <Radio :label="3">
						  <div style="margin-right:10px;cursor: pointer; height: 30px;width: 30px;background-color: #ededed;border-radius: 50%;"></div>
					  </Radio>
					</RadioGroup> -->
						</div>
					</div>

					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.textColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.textColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'textColor', '#000')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<div class="block-title">组件样式</div>
					<!-- <div class="block-item block-item-class">
                <span class="label">上下边距</span>
                <div class="item-slider">
                  <el-slider
                    style="width: 160px"
                    v-model="curItem.style.paddingTop"
                    :min="0"
                    :max="50"
                  />
                  <span class="unit-text">
                    <span>{{ curItem.style.paddingTop }}</span>
                    <span>像素</span>
                  </span>
                </div>
              </div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
			            onEditorResetColor(curItem.style, 'zubackground', '#fff')
			          ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'background', '#fff')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius1')"
							v-model="curItem.style.borderRadius1" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 图标组 -->
			<div v-if="curItem.type == 'moduleimg'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
	      <el-tab-pane key="1" label="内容设置"> -->
				<div class="sub-title">
					添加图标 (最少4个，最多20个，可拖动排序)
				</div>
				<draggable :list="curItem.data" v-bind="{
	            animation: 120,
	            filter: 'input',
	            preventOnFilter: false,
	          }">
					<div v-for="(item, index) in curItem.data" :key="index" style="margin-top: 10px;" class="block-box drag drage-banner">
						<div class="block-title">
							<!-- <span class="left">导航 {{ index + 1 }}</span> -->
							<a class="link" @click="handleDeleleData(curItem, index)"><i class="el-icon-error"></i></a>
						</div>
						<div class="block-item">
							<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
							<div class="block-item-custom">
								<SImage v-model="item.imgUrl" tips="建议尺寸100×100" />
							</div>
							<div class="block-item-common">
								<div class="block-item-common-row">
									<!-- <span class="label">名称</span> -->
									<el-input size="small" v-model="item.text" />
								</div>
								<div class="block-item-common-row">
									<!-- <span class="label">链接</span> -->
									<SLink v-model="item.link" />
								</div>
							</div>
						</div>
					</div>
				</draggable>
				<div v-if="curItem.data.length < 20" class="data-add">
					<el-button icon="plus" @click="handleAddData(20)">添加图标</el-button>
				</div>
				<div class="block-box"  style="margin-top: 35px;">
					<!-- <div class="block-title">标题样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">标题内容</span>
						<el-input size="small" v-model="curItem.params.title" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">标题颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.titlecolor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.titlecolor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="  onEditorResetColor(curItem.style, 'titlecolor', '#000') "> 重置 </div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字大小</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.titlefont" :min="0" :max="30" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'titlefont')" v-model="curItem.style.titlefont"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字加粗</span>
						<el-radio-group v-model="curItem.style.titleweight" type="button">
							<el-radio :label="1">正常</el-radio>
							<el-radio :label="2">加粗</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">每行数量</span>
						<el-radio-group v-model="curItem.style.rowsNum" type="button">
							<el-radio :label="3">3个</el-radio>
							<el-radio :label="4">4个</el-radio>
							<el-radio :label="5">5个</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">按钮形状</span>
						<el-radio-group v-model="curItem.style.navRadius" type="button">
							<el-radio :label="1">正方形</el-radio>
							<el-radio :label="2">圆角</el-radio>
							<el-radio :label="3">圆形</el-radio>
						</el-radio-group>
					</div>

					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.textColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.textColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
	                    onEditorResetColor(curItem.style, 'textColor', '#000')
	                  ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
	  			            onEditorResetColor(curItem.style, 'zubackground', '#fff')
	  			          ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
	                    onEditorResetColor(curItem.style, 'background', '#fff')
	                  ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius1')"
							v-model="curItem.style.borderRadius1" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
			</div>
			
			<!-- 订单图标组 -->
			<div v-if="curItem.type == 'orderimg'" class="editor-content editor-content-banner">
				<div v-for="(item, index) in curItem.data" :key="index" style="margin-top: 10px;" class="block-box drag drage-banner">
					<div class="block-item">
						<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
						<div class="block-item-custom">
							<SImage width="70px" height="70px"  v-model="item.imgUrl" tips="建议尺寸100×100" />
						</div>
						<div class="block-item-common">
							<div class="block-item-common-row">
								<el-input size="small" :placeholder="item.pla" v-model="item.text" />
							</div>
							<!-- <div class="block-item-common-row">
								<SLink v-model="item.link" />
							</div> -->
						</div>
					</div>
				</div>
				<div class="block-box" style="margin-top:25px">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
							onEditorResetColor(curItem.style, 'zubackground', '#fff')
						  ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius1')"
							v-model="curItem.style.borderRadius1" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
			</div>
			
			<!-- 列表导航 -->
			<div v-if="curItem.type == 'modulelise'" class="editor-content editor-content-banner">
				<div class="sub-title">
					添加导航  (不传图标则不显示图标，可拖动排序)
				</div>
				<draggable :list="curItem.data" v-bind="{
	  animation: 120,
	  filter: 'input',
	  preventOnFilter: false,
	}">
					<div v-for="(item, index) in curItem.data" :key="index" style="margin-top: 10px;" class="block-box drag drage-banner">
						<div class="block-title">
							<a class="link" @click="handleDeleleData(curItem, index)"><i class="el-icon-error"></i></a>
						</div>
						<div class="block-item">
							<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
							<div class="block-item-custom">
								<SImage width="70px" height="70px" v-model="item.imgUrl" tips="建议尺寸100×100" />
							</div>
							<div class="block-item-common">
								<div class="block-item-common-row">
									<el-input size="small" v-model="item.text" />
								</div>
								<div class="block-item-common-row">
									<SLink v-model="item.link" />
								</div>
							</div>
						</div>
					</div>
				</draggable>
				<div v-if="curItem.data.length < 20" class="data-add" style="margin-bottom: 35px;">
					<el-button icon="plus" @click="handleAddData(20)">添加导航</el-button>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">内容样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">图标状态</span>
						<el-radio-group v-model="curItem.params.imgshow" type="button">
							<el-radio :label="1">显示</el-radio>
							<el-radio :label="2">隐藏</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.textColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.textColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			  onEditorResetColor(curItem.style, 'textColor', '#000')
			">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
							onEditorResetColor(curItem.style, 'zubackground', '#fff')
						  ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			  onEditorResetColor(curItem.style, 'background', '#fff')
			">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">底边颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.bordercolor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.bordercolor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			  onEditorResetColor(curItem.style, 'bordercolor', '#fff')
			">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">行间距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.lineheight" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'lineheight')" v-model="curItem.style.lineheight"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
			</div>
			<!-- 个人中心 -->
			<div v-if="curItem.type == 'userhead'" class="editor-content editor-content-banner">
				<div class="block-box">
					<!-- <div class="block-title">基础配置</div> -->
					<div class="block-item block-item-class">
						<span class="label">头部样式</span>
						<el-radio-group  v-model="curItem.params.type" type="button">
							<el-radio label="1">默认背景</el-radio>
							<el-radio label="2">背景颜色</el-radio>
							<el-radio label="3">背景图片</el-radio>
						</el-radio-group>
					</div>
					<div v-if="curItem.params.type=='2'" class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'background', '#f9f9f9') ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div v-if="curItem.params.type=='3'" style="margin-bottom: 0;" class="block-item block-item-class">
						<span class="label">背景图片</span>
						<div class="item-colorPicker">
							<div class="block-item-custom">
								<SImage  width="70px" height="30px" v-model="curItem.style.backgroundimg" tips="建议尺寸宽750"  />
							</div>
						</div>
					</div>
					<div v-if="curItem.params.type=='3'" class="block-item block-item-class">
						<span class="label" style="opacity: 0;">等级图片</span>
						<small style="color: #999;margin-left: 10px;">（建议尺寸750*360）</small>
					</div>
					<div class="block-item block-item-class">
						<span class="label">昵称颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.namecolor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.namecolor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'namecolor', '#000') ">
									重置
								</div>
							</div>
						</div>
					</div>
					<!-- <div class="block-title">等级配置</div> -->
					<div class="block-item block-item-class">
					  <span class="label">等级显示</span>
					  <div class="item-checkbox" :style="{ width: '500px' }">
					    <el-checkbox-group v-model="curItem.params.level">
					      <el-checkbox label="member" style="margin-right: 15px;">会员等级</el-checkbox>
					      <el-checkbox label="distribution" style="margin-right: 15px;">分销等级</el-checkbox>
					    </el-checkbox-group>
					  </div>
					</div>
					<div v-if="radioF(curItem.params.level,'member')" class="block-item block-item-class" style="margin-bottom: 0;">
						<span class="label">会员图标</span>
						<div class="item-colorPicker">
							<div class="block-item-custom">
								<SImage :width="40" :height="40" v-model="curItem.style.levelimg" tips="建议尺寸宽80*80"  />
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.params.level,'member')" class="block-item block-item-class">
						<span class="label" style="opacity: 0;">等级图片</span>
						<small style="color: #999;margin-left: 10px;">（建议尺寸80*80）</small>
					</div>
					<div v-if="radioF(curItem.params.level,'member')" class="block-item block-item-class">
						<span class="label">会员颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.levelcolor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.levelcolor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'levelcolor', '#000') ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.params.level,'member')" class="block-item block-item-class">
						<span class="label">会员背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.levelbg" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.levelbg" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'levelbg', '#000') ">
									重置
								</div>
							</div>
						</div>
					</div>
					
					<div v-if="radioF(curItem.params.level,'distribution')" class="block-item block-item-class" style="margin-bottom: 0;">
						<span class="label">分销图标</span>
						<div class="item-colorPicker">
							<div class="block-item-custom">
								<SImage :width="40" :height="40" v-model="curItem.style.distributionimg" tips="建议尺寸宽80*80"  />
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.params.level,'distribution')" class="block-item block-item-class">
						<span class="label" style="opacity: 0;">等级图片</span>
						<small style="color: #999;margin-left: 10px;">（建议尺寸80*80）</small>
					</div>
					<div v-if="radioF(curItem.params.level,'distribution')" class="block-item block-item-class">
						<span class="label">分销颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.distributioncolor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.distributioncolor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'distributioncolor', '#000') ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.params.level,'distribution')" class="block-item block-item-class">
						<span class="label">分销背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.distributionbg" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.distributionbg" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'distributionbg', '#000') ">
									重置
								</div>
							</div>
						</div>
					</div>
					
					<!-- <div class="block-title">按钮配置</div> -->
					<div class="block-item block-item-class">
						<span class="label">设置按钮</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'set',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'set')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'set',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'set')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'set')" class="block-item block-item-class" style="margin-bottom: 0;">
						<span class="label">设置图标</span>
						<div class="item-colorPicker">
							<div class="block-item-custom">
								<SImage :width="40" :height="40" v-model="curItem.style.setimg" tips="建议尺寸宽80*80"  />
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'set')" class="block-item block-item-class">
						<span class="label" style="opacity: 0;">等级图片</span>
						<small style="color: #999;margin-left: 10px;">（建议尺寸80*80）</small>
					</div>
					<div class="block-item block-item-class">
						<span class="label">客服按钮</span>
						<div class="" style="display:flex">
							<div @click="checkR(curItem.style.show,'service',true)" class="s_r">
								<span v-if="radioF(curItem.style.show,'service')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">显示</span>
							</div>
							<div @click="checkR(curItem.style.show,'service',false)" class="s_r">
								<span v-if="!radioF(curItem.style.show,'service')" class="s_radio_y">
									<span class="s_radio_active"></span>
								</span>
								<span v-else class="s_radio">
								</span>
								<span style="margin-left: 3px;">不显示</span>
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'service')" class="block-item block-item-class" style="margin-bottom:0">
						<span class="label">客服图标</span>
						<div class="item-colorPicker">
							<div class="block-item-custom">
								<SImage :width="40" :height="40" v-model="curItem.style.serviceimg" tips="建议尺寸宽80*80"  />
							</div>
						</div>
					</div>
					<div v-if="radioF(curItem.style.show,'service')" class="block-item block-item-class">
						<span class="label" style="opacity: 0;">等级图片</span>
						<small style="color: #999;">（建议尺寸80*80）</small>
					</div>
					<!-- <div class="block-title">财务设置</div> -->
					<div class="block-item block-item-class">
						<span class="label">财务设置</span>
					  <div class="item-checkbox" :style="{ width: '500px' }">
					    <el-checkbox-group v-model="curItem.params.but">
					      <el-checkbox label="balance" style="margin-right: 15px;">余额</el-checkbox>
					      <el-checkbox label="points" style="margin-right: 15px;">积分</el-checkbox>
					      <el-checkbox label="coupon" style="margin-right: 15px;">礼券</el-checkbox>
					      <el-checkbox label="contribution" style="margin-right: 15px;">贡献值</el-checkbox>
					      <el-checkbox label="life" style="margin-right: 15px;">礼品卡</el-checkbox>
					    </el-checkbox-group>
					  </div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.financetext" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.financetext" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'financetext', '#999') ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">数字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.financenum" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.financenum" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'financenum', '#f00') ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 会员卡 -->
			<div v-if="curItem.type == 'modulepay'" class="editor-content editor-content-banner">
				<div class="block-box">
					<!-- <div class="block-title">卡片配置</div> -->
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'zubackground', '#f9f9f9') ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">卡片样式</span>
						<el-radio-group v-model="curItem.params.type" type="button">
							<el-radio label="1">背景图片</el-radio>
							<el-radio label="2">背景颜色</el-radio>
						</el-radio-group>
					</div>
					<div v-if="curItem.params.type=='2'" class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'background', '#f9f9f9') ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div v-if="curItem.params.type=='1'" style="margin-bottom: 0;" class="block-item block-item-class">
						<span class="label">背景图片</span>
						<div class="item-colorPicker">
							<div class="block-item-custom">
								<SImage  width="70px" height="30px" v-model="curItem.style.backgroundimg" tips="建议尺寸宽750"  />
							</div>
						</div>
					</div>
					<div v-if="curItem.params.type=='1'" class="block-item block-item-class">
						<span class="label" style="opacity: 0;">等级图片</span>
						<small style="color: #999;margin-left: 10px;">（建议尺寸370*42）</small>
					</div>
					<div class="block-item block-item-class">
						<span class="label">等级标题</span>
						<el-input size="small" v-model="curItem.params.title" />
					</div>
					<div class="block-item block-item-class">
						<span class="label">等级提示</span>
						<el-input size="small" v-model="curItem.params.tips" />
					</div>
					<div class="block-item block-item-class" style="margin-bottom: 0;">
						<span class="label">等级图标</span>
						<div class="item-colorPicker">
							<div class="block-item-custom">
								<SImage :width="40" :height="40" v-model="curItem.style.icon" tips="建议尺寸宽80*80"  />
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label" style="opacity: 0;">等级图片</span>
						<small style="color: #999;margin-left: 10px;">（建议尺寸80*80）</small>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.color" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.color" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click=" onEditorResetColor(curItem.style, 'color', '#000') ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
			</div>
					
			<!-- 按钮组 -->
			<div v-if="curItem.type == 'modulebut'" class="editor-content editor-content-banner">
				<div class="sub-title">
					添加按钮  (可拖动排序)
				</div>
				<draggable :list="curItem.data" v-bind="{
	  animation: 120,
	  filter: 'input',
	  preventOnFilter: false,
	}">
					<div v-for="(item, index) in curItem.data" :key="index" class="block-box drag drage-banner">
						<div class="block-title">
							<a class="link" @click="handleDeleleData(curItem, index)"><i class="el-icon-error"></i></a>
						</div>
						<div class="block-item">
							<img src="@/assets/icon/icon-move.png" alt="" style="width: 20px; height: 20px" />
							<div class="block-item-custom">
								<SImage v-model="item.imgUrl" tips="建议尺寸100×100" />
							</div>
							<div class="block-item-common">
								<div class="block-item-common-row">
									<el-input size="small" v-model="item.text" />
								</div>
								<div class="block-item-common-row">
									<SLink v-model="item.link" />
								</div>
							</div>
						</div>
					</div>
				</draggable>
				<div v-if="curItem.data.length < 20" class="data-add">
					<el-button icon="plus" @click="handleAddData(20)">添加按钮</el-button>
				</div>
				<div class="block-box">
					<div class="block-title">内容样式</div>
					<div class="block-item block-item-class">
						<span class="label">图标状态</span>
						<RadioGroup v-model="curItem.params.imgshow" type="button">
							<Radio :label="1">显示</Radio>
							<Radio :label="2">隐藏</Radio>
						</RadioGroup>
					</div>
					<div class="block-item block-item-class">
						<span class="label">文字颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.textColor" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.textColor" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			  onEditorResetColor(curItem.style, 'textColor', '#000')
			">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="block-box">
					<div class="block-title">组件样式</div>
					<div class="block-item block-item-class">
						<span class="label">组件背景</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.zubackground"
									defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.zubackground" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#fff"></SInput>
								</div>
								<div class="color-txt" @click="
							onEditorResetColor(curItem.style, 'zubackground', '#fff')
						  ">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			  onEditorResetColor(curItem.style, 'background', '#fff')
			">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">分割颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.bordercolr" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.bordercolr" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
			  onEditorResetColor(curItem.style, 'bordercolr', '#fff')
			">
									重置
								</div>
							</div>
						</div>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
							size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">圆角</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.borderRadius" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'borderRadius')"
							v-model="curItem.style.borderRadius" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
			</div>
			<!-- 图片橱窗 -->
			<div v-if="curItem.type == 'window'" class="editor-content editor-content-banner">
				<!-- <el-tabs>
          <el-tab-pane key="1" label="内容设置"> -->
				<div class="sub-title">添加图片 (最多10个，可拖动排序)</div>
				<draggable :list="curItem.data" v-bind="{
                animation: 120,
                filter: 'input',
                preventOnFilter: false,
              }">
					<div v-for="(item, index) in curItem.data" :key="index" style="margin-top:10px" class="block-box drag drage-banner">
						<div class="block-title">
							<!-- <span class="left">图片 {{ index + 1 }}</span> -->
							<a class="link" @click="handleDeleleData(curItem, index)"><i class="el-icon-error"></i></a>
						</div>
						<div class="block-item">
							<div class="block-item-custom">
								<SImage width="70px" height="70px" v-model="item.imgUrl" @update="item.imgName = $event.file_name" />
							</div>
							<div class="block-item-common">
								<div class="block-item-common-row">
									<span class="label">名称</span>
									<span class="label value">{{ item.imgName }}</span>
								</div>
								<div class="block-item-common-row">
									<!-- <span class="label">链接</span> -->
									<SLink v-model="item.link" />
								</div>
							</div>
						</div>
					</div>
				</draggable>
				<div v-if="curItem.data.length < 10" class="data-add">
					<el-button icon="plus" @click="handleAddData(10)">添加图片</el-button>
				</div>
				<!-- </el-tab-pane>
          <el-tab-pane key="2" label="样式设置"> -->
				<div class="block-box">
					<!-- <div class="block-title">内容样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">每行数量</span>
						<el-radio-group v-model="curItem.style.layout" type="button">
							<el-radio :label="2">2列</el-radio>
							<el-radio :label="3">3列</el-radio>
							<el-radio :label="4">4列</el-radio>
							<el-radio :label="-1">橱窗</el-radio>
						</el-radio-group>
					</div>
					<div class="block-item block-item-class">
						<span class="label">上下边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
							v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
					<div class="block-item block-item-class">
						<span class="label">左右边距</span>
						<div class="item-slider">
							<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
						</div>
						<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
							v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
							placeholder="请输入">
							<span slot="suffix" class="input_text" style="">PX</span>
						</el-input>
					</div>
				</div>
				<div class="block-box">
					<!-- <div class="block-title">组件样式</div> -->
					<div class="block-item block-item-class">
						<span class="label">背景颜色</span>
						<div class="item-colorPicker">
							<div class="color-picker-box">
								<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
							</div>
							<div class="reset-color">
								<div class="ipt">
									<SInput v-model="curItem.style.background" width="100px" height="32px"
										border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
								</div>
								<div class="color-txt" @click="
                        onEditorResetColor(curItem.style, 'background', '#fff')
                      ">
									重置
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- </el-tab-pane>
        </el-tabs> -->
			</div>

			<!-- 热区组 -->
			<div v-if="curItem.type == 'hotZone'" class="editor-content editor-content-banner">
					<!-- <el-tabs>
			  <el-tab-pane key="1" label="内容设置"> -->
			
					<div class="block-box" style="margin-bottom: 35px;">
						<!-- <div class="block-title">
							<span class="left">背景图片</span>
						</div> -->
						<div class="block-item block-item-custom-l20">
							<div class="block-item-custom">
								<SImage width="70px" height="70px" v-model="curItem.data.imgUrl" tips="建议尺寸宽750"
									@update="curItem.data.imgName = $event.filename" />
							</div>
							<div class="block-item-common">
								<div class="block-item-common-row">
									<span class="label">实现点击图片不同位置，跳转不同的链接</span>
									<!-- <span class="label value">{{ curItem.data.imgName }}</span> -->
								</div>
								<div class="block-item-common-row">
									<!-- <span class="label">链接</span> -->
									<SHotZone v-model="curItem.data.maps" :image="curItem.data.imgUrl" />
								</div>
							</div>
						</div>
						<!-- <div class="sub-title">实现点击图片不同位置，跳转不同的链接</div> -->
					</div>
					
					<!-- </el-tab-pane>
			  <el-tab-pane key="2" label="样式设置"> -->
					<div class="block-box" >
						<!-- <div class="block-title">组件样式</div> -->
						<div class="block-item block-item-class">
							<span class="label">组件背景</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.background" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
				            onEditorResetColor(curItem.style, 'background', '#fff')
				          ">
										重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">上边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingTop" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingTop')"
								v-model="curItem.style.paddingTop" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">下边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingBottom" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingBottom')"
								v-model="curItem.style.paddingBottom" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">左边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingLeft" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingLeft')"
								v-model="curItem.style.paddingLeft" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">右边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingRight" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingRight')"
								v-model="curItem.style.paddingRight" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">上圆角</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.radiusTop" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'radiusTop')" v-model="curItem.style.radiusTop"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">下圆角</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.radiusBottom" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'radiusBottom')"
								v-model="curItem.style.radiusBottom" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
					</div>
					<!-- </el-tab-pane>
			</el-tabs> -->
			</div>

			<!-- 标题文本 -->
				<div v-if="curItem.type == 'title'" class="editor-content editor-content-banner">
					<!-- <el-tabs>
			  <el-tab-pane key="1" label="内容设置"> -->
					<div class="block-box">
						<!-- <div class="block-title">标题内容</div> -->
						<div class="block-item block-item-class">
							<span class="label">标题文字</span>
							<el-input size="small" v-model="curItem.params.title" />
						</div>
						<div class="block-item block-item-class">
							<span class="label">标题大小</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.params.titleFontSize" :min="12" :max="18" />
							</div>
							<el-input type="number" @input="e=>changeInputParam(e,'titleFontSize')"
								v-model="curItem.params.titleFontSize" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">标题字体</span>
							<el-radio-group v-model="curItem.params.titleFontWeight" type="button">
								<el-radio label="normal">常规</el-radio>
								<el-radio label="bold">加粗</el-radio>
							</el-radio-group>
						</div>
					</div>
					<div class="block-box">
						<!-- <div class="block-title">描述内容</div> -->
						<div class="block-item block-item-class">
							<span class="label">描述文字</span>
							<el-input size="small" v-model="curItem.params.desc" />
						</div>
						<div class="block-item block-item-class">
							<span class="label">描述大小</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.params.descFontSize" :min="12" :max="18" />
							</div>
							<el-input type="number" @input="e=>changeInputParam(e,'descFontSize')"
								v-model="curItem.params.descFontSize" size="mini" style="width: 150px;margin-left: 10px;"
								placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">描述字体</span>
							<el-radio-group v-model="curItem.params.descFontWeight" type="button">
								<el-radio label="normal">常规</el-radio>
								<el-radio label="bold">加粗</el-radio>
							</el-radio-group>
						</div>
					</div>
					<div class="block-box">
						<!-- <div class="block-title">查看更多</div> -->
						<div class="block-item block-item-class">
							<span class="label">是否显示</span>
							<el-radio-group v-model="curItem.params.more.enable" type="button">
								<el-radio :label="true">显示</el-radio>
								<el-radio :label="false">隐藏</el-radio>
							</el-radio-group>
						</div>
						<div class="block-item block-item-class">
							<span class="label">文字内容</span>
							<el-input size="small" v-model="curItem.params.more.text" />
						</div>
						<div class="block-item block-item-class">
							<span class="label">箭头图标</span>
							<el-radio-group v-model="curItem.params.more.enableIcon" type="button">
								<el-radio :label="true">显示</el-radio>
								<el-radio :label="false">隐藏</el-radio>
							</el-radio-group>
						</div>
						<div class="block-item block-item-class">
							<span class="label">跳转链接</span>
							<SLink v-model="curItem.params.more.link" textAlign="right" />
						</div>
					</div>
					<!-- </el-tab-pane>
			  <el-tab-pane key="2" label="样式设置"> -->
					<div class="block-box">
						<!-- <div class="block-title">内容样式</div> -->
						<div class="block-item block-item-class">
							<span class="label">标题文字颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.titleTextColor"
										defaultColor="#323233" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.titleTextColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
			                onEditorResetColor(
			                  curItem.style,
			                  'titleTextColor',
			                  '#323233'
			                )
			              ">
										重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">描述文字颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.descTextColor"
										defaultColor="#969799" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.descTextColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
			                onEditorResetColor(
			                  curItem.style,
			                  'descTextColor',
			                  '#969799'
			                )
			              ">
										重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">更多文字颜色</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.moreTextColor"
										defaultColor="#969799" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.moreTextColor" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
			                onEditorResetColor(
			                  curItem.style,
			                  'moreTextColor',
			                  '#969799'
			                )
			              ">
										重置
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="block-box">
						<!-- <div class="block-title">组件样式</div> -->
						<div class="block-item block-item-class">
							<span class="label">组件背景</span>
							<div class="item-colorPicker">
								<div class="color-picker-box">
									<el-color-picker size="small" v-model="curItem.style.background" defaultColor="#fff" />
								</div>
								<div class="reset-color">
									<div class="ipt">
										<SInput v-model="curItem.style.background" width="100px" height="32px"
											border-radius="2px 0 0 2px" highlight-color="#006aff"></SInput>
									</div>
									<div class="color-txt" @click="
				            onEditorResetColor(curItem.style, 'background', '#fff')
				          ">
										重置
									</div>
								</div>
							</div>
						</div>
						<div class="block-item block-item-class">
							<span class="label">上边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingY" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingY')" v-model="curItem.style.paddingY"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">下边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingY1" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingY1')" v-model="curItem.style.paddingY1"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">左边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingX" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingX')" v-model="curItem.style.paddingX"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
						<div class="block-item block-item-class">
							<span class="label">右边距</span>
							<div class="item-slider">
								<el-slider style="width: 100%" v-model="curItem.style.paddingX1" :min="0" :max="50" />
							</div>
							<el-input type="number" @input="e=>changeInput(e,'paddingX1')" v-model="curItem.style.paddingX1"
								size="mini" style="width: 150px;margin-left: 10px;" placeholder="请输入">
								<span slot="suffix" class="input_text" style="">PX</span>
							</el-input>
						</div>
			
					</div>
					<!-- </el-tab-pane>
			</el-tabs> -->
			</div>
		</template>
	</div>
</template>

<script>
	import Vue from "vue";
	import OSS from "ali-oss";
	import COS from 'cos-js-sdk-v5';
	// import vcolorpicker from 'vcolorpicker'
	// import PropTypes from 'ant-design-vue/es/_util/vue-types'
	import draggable from "vuedraggable";
	// import { inArray } from '@/utils/util'
	// import { Ueditor, SelectCategory } from '@/components'
	import TinymceEditor from "@/components/TinymceEditor/TinymceEditor";
	import {
		STan,
		SMarks,
		SMarksup,
		SCouponpack,
		SImage,
		SArticleCate,
		SGoods,
		SLink,
		SHotZone,
		SCoupon,
		SInput,
		SGoodsCate,
		SLive1,
		SstoreCate
	} from "./modules";
	// Vue.use(vcolorpicker)
	export default {
		props: {
			// 页面装修默认数据
			defaultData: {},
			// 页面数据
			data: {},
			// 当前选中的元素
			curItem: {},
			// 当前选中的元素索引
			selectedIndex: 0,
		},
		components: {
			SCouponpack,
			draggable,
			SMarks,
			SMarksup,
			// Ueditor,
			TinymceEditor,
			SImage,
			SArticleCate,
			SGoods,
			// SelectCategory,
			SLink,
			SHotZone,
			SCoupon,
			SInput,
			SLive1,
			SGoodsCate,
			SstoreCate
		},
		data() {
			return {
				projectinfo: {
					id: "",
					title: "", //站点名称
					image: "", //站点图标，本地上传文件
					image_url: "", //站点整站图片  本地上传
					description: "", //技术支持
					agreement_title: "", //协议标题
					agreement_content: "", //协议内容
					about_content: "", //站点图标地址
					privacy_content: "", //站点整站图片地址
					is_open: "",
					qiniuToken: "", //视频上传的token
					settingInfo: {},
				},
			};
		},
		beforeCreate() {
			// this.inArray = inArray
		},
		created() {
			this.axios.get("/api/shop/basic/shop-info").then((res) => {
				if (res.code == 200 && res.data) {
					this.projectinfo = res.data;
					console.log("我是店铺信息", this.projectinfo);
				}
			});
			let _this = this;
			// 获取视频上传的token
			_this.axios.get("/api/common/upload-token").then((res) => {
				_this.qiniuToken = res.data.uptoken;
			});
			this.getInfo();
		},
		computed: {
			formattedValue(type) {
				console.log(type)
				// if(this.$util.inArray(type, all)){
				//   return true
				// }else{
				//   return false
				// }
			}
		},
		methods: {
			radioF(all, type) {
				if (this.$util.inArray(type, all)) {
					return true
				} else {
					return false
				}
			},
			radioFun(type, val) {
				this.curItem.style[type] = val
			},
			checkR(all, type, status) {
				if (status) {
					if (this.$util.inArray(type, all)) {

					} else {
						this.curItem.style.show.push(type)
					}
				} else {
					if (this.$util.inArray(type, all)) {
						this.curItem.style.show = this.curItem.style.show.filter(item => item !== type)
					}
				}
			},
			setFun(e) {
				this.curItem.style.navRadius = e
				// this.$forceUpdate()
			},
			changeInput(e, type) {
				this.curItem.style[type] = Number(e)
				// this.$nextTick()
			},
			changeGoods(e, type) {
				this.curItem.params.auto[type] = Number(e)
				// this.$nextTick()
			},
			// 定时关闭只能是大于0的整数
			handleTimeoutInput(value) {
				// 强制转换为正整数
				const num = Math.max(1, parseInt(value) || 1);
				if (value !== num.toString()) {
					this.data.page.params.timeout = num;
				}
			},
			// 移除视频
			handvideOff() {
				// this.post.video_id = "";
				// this.video_url = "";
				this.curItem.params.videoUrl = "";
			},
			// 获取设置
			getInfo() {
				let _this = this;
				_this.axios
					.get("/api/common/shop/admin/upload/setting/index")
					.then((res) => {
						if (res.code == 200) {
							if (res.data) {
								_this.settingInfo = res.data;
							}
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			// 选择视频
			uploadFun(e) {
				let _this = this;
				var timestamp = Date.parse(new Date());
				var date = new Date(timestamp);
				// console.log("==现在时间==")
				var Y = date.getFullYear(); //年
				var M =
					date.getMonth() + 1 < 10 ?
					"0" + (date.getMonth() + 1) :
					date.getMonth() + 1; //月
				var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //日
				var h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //时
				var m =
					date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(); //分
				var s =
					date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); //秒
				const file = this.$refs.fileInput.files[0]; // 获取input file选择的文件
				var tempFormat = file.name.substring(file.name.lastIndexOf(".") + 1);
				var filePath =
					"upload/video/" +
					Y +
					M +
					D +
					"/" +
					Y +
					M +
					D +
					h +
					m +
					s +
					"." +
					tempFormat;
				if (this.settingInfo.storage_type == 1) {
					const formData = new FormData(); // 发送至服务器的数据
					formData.append("file", file); // 添加文件数据到formData
					formData.append("file_type", "file"); // 添加文件数据到formData
					formData.append("key", filePath); // 添加文件数据到formData
					formData.append("token", this.qiniuToken); // 添加文件数据到formData
					// 七牛云
					this.axios.post("https://up-z2.qiniup.com", formData).then((res) => {
						_this.axios
							.post("/api/common/upload-video", {
								file_hash: res.hash,
								file_key: res.key,
								origin_name: "test.mp4",
							})
							.then((resd) => {
								console.log("resd", resd);
								if (resd.code == 200) {
									_this.curItem.params.videoUrl = resd.data.url;
								} else {
									eltips(res.msg, "error");
								}
							});
					});
				} else if (this.settingInfo.storage_type == 2) {
					// 腾讯COS
					this.uploadVideoToCOS(file, filePath);
				} else if (this.settingInfo.storage_type == 3) {
					// 阿里云OSS
					this.handleFileChange(file, filePath);
				}
			},
			// 腾讯云
			async uploadVideoToCOS(file, filePath) {
				let _this = this
				let cos = new COS({
					SecretId: this.settingInfo.access_key, // 替换为你的SecretId
					SecretKey: this.settingInfo.secret_key, // 替换为你的SecretKey
				});
				cos.putObject({
						Bucket: this.settingInfo.bucket,
						Region: this.settingInfo.region,
						Key: filePath,
						Body: file,
					},
					(err, data) => {
						if (err) {
							_this.$refs.fileInput.value = null;
						} else {
							_this.axios
								.post("/api/common/upload-video", {
									file_hash: filePath,
									file_key: filePath,
									origin_name: file.name,
								})
								.then((res) => {
									if (res.code == 200) {
										_this.curItem.params.videoUrl = res.data.url;
									} else {
										eltips(res.msg, "error");
									}
									_this.$refs.fileInput.value = null;
								});
							console.log("data:::", data);
						}
					}
				);
			},
			// 阿里云
			async handleFileChange(event, filePath) {
				let file = event;
				let _this = this;
				const client = new OSS({
					region: this.settingInfo.region.split(".")[0], // 设置Bucket所在地域，例如'oss-cn-hangzhou'
					accessKeyId: this.settingInfo.access_key,
					accessKeySecret: this.settingInfo.secret_key,
					bucket: this.settingInfo.bucket, // 设置Bucket名称//存储空间
				});
				const result = await client.put(filePath, file); // 上传文件到指定的路径下
				console.log("Upload result:", result); // 打印上传结果，包含文件的URL等信息
				_this.axios
					.post("/api/common/upload-video", {
						file_hash: filePath,
						file_key: filePath,
						origin_name: "test.mp4",
					})
					.then((resd) => {
						console.log("resd", resd);
						if (resd.code == 200) {
							_this.curItem.params.videoUrl = resd.data.url;
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			// 获取当前商品分类的数据
			getValue(e) {
				this.curItem.params.auto.category = e;
				let _this = this;
				_this.axios
					.get("/api/weishop/admin/goods/list", {
						params: {
							categoryId: e,
							page: 1,
							limit: this.curItem.params.auto.showNum,
						},
					})
					.then((res) => {
						console.log("我在打印页面详情", res);
						console.log("我在完成赋值", this.curItem);
						if (res.code == 200) {
							this.curItem.defaultData = res.data.data;
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			activeSeckill(e) {
				console.log("商品选择", e)
				this.curItem.super_data.id = e.id;
				this.curItem.super_data.end_time = e.end_time;
				this.curItem.super_data.name = e.name;
				this.curItem.super_data.start_time = e.start_time;
				let _this = this;
				_this.axios.get("/api/weishop/admin/market/super/show/" + e.id)
					.then((res) => {
						console.log("我在打印页面详情", res);
						console.log("我在完成赋值", this.curItem);
						if (res.code == 200) {
							this.curItem.data = (res.data.data.length > 4 ? res.data.data.slice(0, 4) : res.data.data);
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			activeCouponpack(e) {
				console.log(e)
				// this.curItem.super_data.id = e.id;
				// this.curItem.super_data.end_time = e.end_time;
				// this.curItem.super_data.name = e.name;
				// this.curItem.super_data.start_time = e.start_time;
				let _this = this;
				_this.axios.get("/api/weishop/admin/plugin/couponpack/detail/" + e.id)
					.then((res) => {
						if (res.code == 200) {
							this.curItem.data = res.data.coupon;
						} else {
							eltips(res.msg, "error");
						}
					});
			},
			// 广告
			handleAddAd(max = 1) {
				// const { defaultData, data.page.params.adsList } = this;
				// const newDataItem = defaultData.items[curItem.type].data[0];
				// curItem.data.push(_.cloneDeep(newDataItem));
				this.data.page.params.adsList.push({
					imgUrl: "https://qiniuyun.mocols.com/upload/images/20250314/202503141448459974.png",
					imgName: "image-1.jpg",
					link: null,
				})
			},
			handleDeleleAd(index) {
				// if (curItem.data.length <= 1) {
				//   this.$message.warning("至少保留一个");
				//   return false;
				// }
				this.data.page.params.adsList.splice(index, 1);
			},
			// 新增数据
			handleAddData(max = 1) {
				const {
					defaultData,
					curItem
				} = this;
				const newDataItem = defaultData.items[curItem.type].data[0];
				curItem.data.push(_.cloneDeep(newDataItem));
			},
			/**
			 * 编辑器删除data元素
			 * @param curItem
			 * @param index
			 */
			handleDeleleData(curItem, index) {
				if (curItem.data.length <= 1) {
					this.$message.warning("至少保留一个");
					return false;
				}
				curItem.data.splice(index, 1);
			},
			// 新增数据
			handleAddSwipter(max = 1) {
				const {
					curItem
				} = this;
				curItem.swipter.push({
					imgUrl: "https://qiniuyun.mocols.com/upload/images/20250314/202503141448459974.png",
					imgName: "image-1.jpg",
					link: null,
				});
			},
			/**
			 * 编辑器删除data元素
			 * @param curItem
			 * @param index
			 */
			handleDeleleSwipter(curItem, index) {
				// if (curItem.swipter.length <= 1) {
				//   this.$message.warning("至少保留一个");
				//   return false;
				// }
				curItem.swipter.splice(index, 1);
			},

			/**
			 * 重置颜色
			 * @param holder
			 * @param attribute
			 * @param color
			 */
			onEditorResetColor(holder, attribute, color) {
				holder[attribute] = color;
			},
		},
	};
</script>
<style lang="less" scoped>
	@import "./style.less";
	@import "./iconfont_uni.css";

	::v-deep .el-tabs__item.is-active {
		font-weight: bold;
	}

	::v-deep .el-tabs__header {
		border-bottom: 1px solid #f5f5f5 !important;
		display: flex;
		justify-content: flex-start;
	}

	::v-deep .el-tabs__active-bar {
		height: 2px;
	}

	::v-deep .el-tabs__nav-wrap::after {
		content: "";
		height: 0;
		background-color: none;
	}

	.navstyle ::v-deep .ivu-radio-group-button {
		border: 0 !important
	}

	.navstyle ::v-deep .ivu-radio-group-button .ivu-radio-wrapper:first-child {
		border: 0 !important
	}

	.navstyle ::v-deep .ivu-radio-group-button .ivu-radio {
		display: none !important
	}

	.navstyle ::v-deep .ivu-radio-group-button .ivu-radio-wrapper {
		border: 0 !important
	}

	.navstyle ::v-deep .ivu-radio-group-button .ivu-radio-wrapper:after,
	.ivu-radio-group-button .ivu-radio-wrapper:before {
		width: 0 !important
	}

	.modeItem {
		margin-left: 10px;
		border-left: 1px solid #e4e4e4;
	}

	.block-item ::v-deep .input_text {
		width: 30px;
	}

	.block-item ::v-deep .el-input__inner {
		padding: 0 10px
	}

	.s_radio {
		height: 16px;
		width: 16px;
		display: block;
		border: 1px solid #E4E7ED;
		border-radius: 50% 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.s_radio_y {
		height: 16px;
		width: 16px;
		display: block;
		border: 1px solid #006aff;
		border-radius: 50% 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.s_radio_active {
		height: 10px;
		width: 10px;
		border-radius: 50% 50%;
		display: block;
		background: #006aff;
		position: reactive;

	}

	.s_r {
		cursor: pointer;
		margin-right: 20px;
		align-items: center;
		display: flex;
		align-items: center;
	}

	.dancheck ::v-deep .ivu-radio-group-button .ivu-radio-wrapper {
		padding: 0 8px;
	}
</style>